import { formatDistance } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';
import { updateEpikBox, saveCurrentBoxData } from '../../../actions/EpikBoxes';
import del from '../../../Res/Icon/delete.png';
import edit from '../../../Res/Icon/edit.png';
import notesIcon from '../../../Res/Icon/notes.png';
import recover from '../../../Res/Icon/recover.png';
import view from '../../../Res/Icon/view.png';
import Toggle from '../../Toggle';
import { ReactComponent as Favorite } from '../../../Res/svg/favorite.svg';
import utils from '../../../lib/utils';

const EpixBoxesListRow = ({
  box,
  onBoxClick,
  onBoxCheck,
  onUpdateBox,
  onBoxDelete,
  user,
  updateBoxMonitor,
  deleteMode,
  onRecover,
  checked,
  showNotesModal,
  selectedBox,
  saveCurrentBoxData,
  onRemoveFavorite,
  onAddFavorite,
  userFavoriteBoxes,
}) => {
  const lastUpdatedDistanceValue = lastUpdated => {
    const distanceValue = lastUpdated
      ? formatDistance(new Date(), new Date(lastUpdated), {
        addSuffix: false,
      })
      : '-';
    
    return {
      value: distanceValue,
      isOld: lastUpdated && utils.isOlderThan24Hours(lastUpdated)
    };
  };

  const boxDelete = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    onBoxDelete(box);
  };

  const onRecoverBox = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    onRecover(box);
  };

  const handleUpdateBox = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    onUpdateBox(box);
  };

  const fieldClicked = ev => {
    ev.stopPropagation();
    saveCurrentBoxData('')
    onBoxClick(box);
  };

  const handleNotes = ev => {
    ev.preventDefault();
    saveCurrentBoxData(box._id)
    ev.stopPropagation();
    selectedBox(box._id);
    showNotesModal(true);
  };

  return (
    <tr className="row-hover"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onBoxClick(box); }
    }}
    aria-label={[
      `Company ${box.companyName || 'Unknown'}`,
      `Edge Device name ${box.boxName || 'Unknown'}`,
      `Serial Number ${box.serialNumber || 'Unknown'}`,
      `Location ${box?.locRef?.locationName || 'None'}`,
      `Registration ${box.status ? 'Registered' : 'Unregistered'}`,
      `Ports ${box.ports ?? box.numPorts ?? 0}`,
      `Notes ${'Notes'}`,
      `Monitoring ${box.monitor ? 'enabled' : 'disabled'}`,
      `Actions available`
    ].join(', ')}
    >
      <>
        <td>
          <label className="custom-control custom-checkbox">
            <input
              type="checkbox"
              onChange={e => onBoxCheck(e.currentTarget.checked, box)}
              checked={checked}
              className="custom-control-input"
            />
            <span className="custom-control-label ml-1"></span>
          </label>
        </td>
      </>
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {box.companyName || ''}
      </td>
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {' '}
        {box.boxName || box.displayName}{' '}
      </td>
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {box.serialNumber}
      </td>
      {/* <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {(() => {
          const result = lastUpdatedDistanceValue(box?.registeredChangedAt);
          return (
            <span style={result.isOld ? { color: 'red', fontWeight: 500 } : {}}>
              {result.value}
            </span>
          );
        })()}
      </td> */}
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {box.locRef ? box.locRef.locationName : ''}
      </td>
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {box.status ? 'Registered' : 'UnRegistered'}
      </td>
      <td
        onClick={ev => {
          fieldClicked(ev);
        }}
      >
        {' '}
        {box.ports ?? box.numPorts}
      </td>
      {(user?.role === 'superAdmin' || user?.role === 'companyGroupAdmin') && (
      <td onClick={ev => handleNotes(ev)}>
        <img className="actions-icon" src={notesIcon} alt="..." />
      </td>
      )}

      {/* <td style={{ display: 'flex', justifyContent: 'center' }}>
        <Toggle
          value={box.monitor}
          onToggle={e => updateBoxMonitor({ monitor: !box.monitor, _id: box._id })}
        />
      </td> */}
         <td style={{ display: 'flex', justifyContent: 'center' , marginTop:'10px' }}>
        <div
          style={{
            backgroundColor: box?.monitor ? '#007bff' : '#d3d3d3', // Blue if enabled, Grey if disabled
            borderRadius: '50%',
            height: '1.1rem',
            width: '1.1rem',
          }}
        ></div>
      </td>
      <td >
        {user.role !== 'companyGroupManager' ? (
          <>
            {
              userFavoriteBoxes?.includes(box?._id) ? (
                <Favorite
                  fill='#4d9cd3'
                  id="remove-fav" className="favorite-size" onClick={onRemoveFavorite} />
              ) : (
                <Favorite
                  id="remove-fav" className="favorite-size" onClick={onAddFavorite} />
              )
            }
            {
              (user.role === 'enterpriseAdmin' || user.role === 'admin') ? null :
                !deleteMode ? (
                  <img
                    onClick={ev => {
                      handleUpdateBox(ev);
                    }}
                    className="actions-icon"
                    src={edit}
                    alt="..."
                  />
                ) : (
                  <img
                    onClick={ev => {
                      onRecoverBox(ev);
                    }}
                    className="actions-icon"
                    src={recover}
                    alt="..."
                  />
                )
            }
            <img
              onClick={ev => {
                fieldClicked(ev);
              }}
              className="actions-icon"
              src={view}
              alt="..."
            />
            {(user.role === 'admin' || user.role === 'enterpriseAdmin') ? null : (
              <img
                onClick={ev => {
                  boxDelete(ev);
                }}
                className="actions-icon"
                src={del}
                alt="..."
              />
            )}
          </>
        ) : null}
      </td>
    </tr>
  );
};

const mapDispatchToProps = dispatch => ({
  updateBox: (token, box) => dispatch(updateEpikBox(token, box)),
  saveCurrentBoxData: (box) => dispatch(saveCurrentBoxData(box)),
});

export default connect(
  null,
  mapDispatchToProps,
)(EpixBoxesListRow);
